export default {
  token: '3694743763859db7c1adbfbe78626331',
  debug: true
}
